import fetch from "cross-fetch";
import { ApiV1Base, ApiPrefix, statusCheck, json, getCookie } from "../util/icwUtility";
import { actLoginTimedOut } from "./loginStateActions";

//
//  ******* In-memory updated Related *******
//
export const NOTIFICATION_SETTING_INIT = "NOTIFICATION_SETTING_INIT";
export function actNotificationSettingInit() {
    return { type: NOTIFICATION_SETTING_INIT };
}

//
//  ******* Fetch NOTIFICATION Setting Begin *******
//
export const NOTIFICATION_SETTING_FETCH_BEGIN = "NOTIFICATION_SETTING_FETCH_BEGIN";
function actNotificationSettingFetchBegin() {
    return { type: NOTIFICATION_SETTING_FETCH_BEGIN };
}

export const NOTIFICATION_SETTING_FETCH_SUCCESS = "NOTIFICATION_SETTING_FETCH_SUCCESS";
export function actNotificationSettingFetchSuccess(data) {
    return { type: NOTIFICATION_SETTING_FETCH_SUCCESS, data };
}

export const NOTIFICATION_SETTING_FETCH_FAIL = "NOTIFICATION_SETTING_FETCH_FAIL";
function actNotificationSettingFetchFail(reason) {
    return { type: NOTIFICATION_SETTING_FETCH_FAIL, reason };
}

export function actNotificationSettingFetch() {
    return (dispatch, getState) => {
        dispatch(actNotificationSettingFetchBegin());
        return fetch(`${ApiV1Base}${ApiPrefix}/notifications/settings`, {
            headers: { Authorization: getCookie("token") },
        })
            .then(statusCheck)
            .then(json)
            .then(json => dispatch(actNotificationSettingFetchSuccess(json)))
            .catch(err => {
                if (err.status === 401) {
                    dispatch(actLoginTimedOut());
                }

                dispatch(actNotificationSettingFetchFail(typeof err === "object" ? err.message : err));
            });
    };
}


//
//  ******* Update NOTIFICATION Setting Begin *******
//
export const NOTIFICATION_SETTING_UPDATE_BEGIN = "NOTIFICATION_SETTING_UPDATE_BEGIN";
function actNotificationSettingUpdateBegin() {
    return { type: NOTIFICATION_SETTING_UPDATE_BEGIN };
}

export const NOTIFICATION_SETTING_UPDATE_SUCCESS = "NOTIFICATION_SETTING_UPDATE_SUCCESS";
export function actNotificationSettingUpdateSuccess(data) {
    return { type: NOTIFICATION_SETTING_UPDATE_SUCCESS, data };
}

export const NOTIFICATION_SETTING_UPDATE_FAIL = "NOTIFICATION_SETTING_UPDATE_FAIL";
function actNotificationSettingUpdateFail(reason) {
    return { type: NOTIFICATION_SETTING_UPDATE_FAIL, reason };
}

export function actNotificaitonSettingUpdate(data) {
    return (dispatch, getState) => {
        dispatch(actNotificationSettingUpdateBegin());
        return fetch(`${ApiV1Base}${ApiPrefix}/notifications/settings`, {
            method: "POST",
            headers: {
                Authorization: getCookie("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then(statusCheck)
            .then(json)
            .then(json => dispatch(actNotificationSettingUpdateSuccess(json)))
            .catch(err => {
                if (err.status === 401) {
                    dispatch(actLoginTimedOut());
                }

                dispatch(actNotificationSettingUpdateFail(typeof err === "object" ? err.message : err));
            });
    };
}

//
//  ******* Update NOTIFICATION Setting Key End *******
//
